export interface ApiErrors {
  /** Ogólny komunikat z `message` */
  message?: string
  /** Pierwszy komunikat dla każdego pola z `errors` */
  fields: Record<string, string>
  /** Czy backend wysłał już notyfikację (meta.custom.notification) – wtedy nie dublujemy komunikatu */
  hasNotification: boolean
}

/**
 * Parsuje błąd rzucony przez `request` (POST/GET… z `showErrorPopup = false`),
 * który zawiera zserializowane body odpowiedzi, np.
 * `{ message, errors: { password: ['Pole jest wymagane.'] }, meta: { custom: { notification } } }`
 */
export const parseApiErrors = (error: unknown): ApiErrors => {
  let data: any
  try {
    data = typeof error === 'string' ? JSON.parse(error) : error
  } catch {
    data = null
  }

  const fields: Record<string, string> = {}
  const errors = data?.errors
  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
    Object.entries(errors).forEach(([key, value]) => {
      const msg = Array.isArray(value) ? value[0] : value
      if (typeof msg === 'string' && msg) fields[key] = msg
    })
  }

  return {
    message: typeof data?.message === 'string' ? data.message : undefined,
    fields,
    hasNotification: !!data?.meta?.custom?.notification
  }
}

/** Zwraca pierwszy komunikat dla któregokolwiek z podanych pól */
export const pickFieldError = (fields: Record<string, string>, keys: string[]) => {
  const key = keys.find(k => fields[k])
  return key ? fields[key] : ''
}
